import qs from '@scoir/query-string'
import { reduce, upperFirst } from 'lodash'

import getCurrentDateString from 'common/get-current-date-string'

export const formatEventData = (eventData) => {
  eventData.EventTimestamp = getCurrentDateString()
  const formattedEventData = reduce(
    eventData,
    (result, value, key) => {
      result[upperFirst(key)] = value
      return result
    },
    {},
  )
  return formattedEventData
}

export const getHeaders = (data) => {
  return {
    headers: { 'x-scoir-event-data': qs.stringify(data) },
  }
}

export const generateEventDataHeader = (eventData) => {
  const formattedData = formatEventData(eventData)
  return getHeaders(formattedData)
}
